import { getEcpairFromPrivateKey } from '@optimex-xyz/btc-script'
import { getSolanaUserEphemeralKeys } from '@optimex-xyz/solana-smartcontract'

import { ethers, SigningKey, Wallet } from 'ethers'
import * as tools from 'uint8array-tools'

import { ensureHexPrefix } from './trade'

export const getEphemeral = (hexSignature: string) => {
  const ephemeralAssetChainPrivateKey = Buffer.from(ethers.toUtf8Bytes(hexSignature).slice(0, 32)).toString('hex')

  const ephemeralL2ConfigPrivateKey = Buffer.from(ethers.toUtf8Bytes(hexSignature).slice(-32)).toString('hex')

  const solWallet = getSolanaUserEphemeralKeys(hexSignature)

  return {
    l2: new Wallet(ephemeralL2ConfigPrivateKey),
    assetChain: {
      evm: new Wallet(ephemeralAssetChainPrivateKey),
      sol: solWallet,
      btc: getEcpairFromPrivateKey(ephemeralAssetChainPrivateKey),
    },
    publicKey(type: 'l2' | 'assetChain', network?: string) {
      if (type === 'l2') {
        return ensureHexPrefix(this.l2.signingKey.publicKey)
      }

      switch (network?.toUpperCase()) {
        case 'EVM': {
          return ensureHexPrefix(SigningKey.computePublicKey(this.assetChain.evm.signingKey.publicKey, true))
        }
        case 'SOLANA':
          return this.assetChain.sol.publicKey.toBase58()
        case 'BTC':
          return tools.toHex(this.assetChain.btc.publicKey)
        default: {
          throw new Error('Invalid network type')
        }
      }
    },
    privateKey(type: 'l2' | 'assetChain') {
      if (type === 'l2') {
        return ephemeralL2ConfigPrivateKey
      }

      return ephemeralAssetChainPrivateKey
    },
  }
}

export type EphemeralInfo = ReturnType<typeof getEphemeral>
